export default __webpack_public_path__ + "static/media/story.892dd787.jpg";